// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#2F3236"
      d="M12 4V4C13.3297 9.99124 18.0088 14.6703 24 16V16 16C18.0088 17.3297 13.3297 22.0088 12 28V28 28C10.6703 22.0088 5.99124 17.3297 0 16V16 16C5.99124 14.6703 10.6703 9.99124 12 4V4ZM22 0V0C22.6648 2.99562 25.0044 5.33515 28 6V6 6C25.0044 6.66485 22.6648 9.00438 22 12V12 12C21.3352 9.00438 18.9956 6.66485 16 6V6 6C18.9956 5.33515 21.3352 2.99562 22 0V0Z"
    />
  </svg>
);
const IconAiStars = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconAiStars;
